import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PipesModule, UserAvatarComponent } from '@aionzdev/design-system';
import { AttachmentOriginType, PurchaseRequestAttachmentGroup } from '../../../interfaces/purchase-request-attachment-group';
import { PurchaseRequestAttachment } from '../../../interfaces/purchase-request-attachment';
import { AttachmentCardComponent } from '../../atoms/attachment-card/attachment-card.component';

@Component({
  selector: 'aionz-attachment-group',
  imports: [UserAvatarComponent, AttachmentCardComponent, PipesModule],
  templateUrl: './attachment-group.component.html',
  styleUrl: './attachment-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentGroupComponent {
  public group = input.required<PurchaseRequestAttachmentGroup>();
  public downloadAttachment = output<PurchaseRequestAttachment>();

  protected readonly originDescription = computed(() => {
    return this.group().type === AttachmentOriginType.REQUESTER
      ? 'solicitante'
      : 'Fornecedor';
  });

}
